import { URL } from '@/api/baseUrl.js'

// 登录及主页api
export default {
    login: '/authserver/api/login/account',//登录
    getCode:'/wechatapp/vito/login/getSmsCode', //发送验证码
    rebackPwd:'/authserver/sys/sysuser/forgetPassword',//通过验证码找回密码

    getUserInfo:'/pms/api/login/login',
    getMenu:"/pms/pms/roleresource/getPcMenu",//获取路由
    resetPwd:"/authserver/sys/sysuser/updatePassword" //修改密码
}
